export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  rating: number;
  genre: string;
  region: string;
  duration: string;
  quality: string;
  description: string;
  imageUrl: string;
  isHot: boolean;
  isNew: boolean;
  cast: string[];
}

export interface TVShow {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  rating: number;
  genre: string;
  region: string;
  episodes: number;
  quality: string;
  description: string;
  imageUrl: string;
  isHot: boolean;
  isNew: boolean;
  cast: string[];
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'action', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情片', icon: 'ri-film-line' },
  { slug: 'sci-fi', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'romance', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'animation', name: '动画片', icon: 'ri-palette-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const hotMovies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    year: 2026,
    rating: 8.6,
    genre: '科幻',
    region: '中国大陆',
    duration: '148分钟',
    quality: '蓝光1080P',
    description: '太阳急速老化膨胀，人类面临灭顶之灾。面对绝境，人类将开启"流浪地球计划"，试图带着地球一起逃离太阳系，寻找新的家园。第三部将展开更宏大的星际叙事，人类文明面临前所未有的考验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20poster%20with%20astronaut%20facing%20giant%20planet%2C%20dramatic%20orange%20and%20deep%20space%20lighting%2C%20film%20poster%20style%2C%20Chinese%20sci-fi%20blockbuster%20aesthetic%2C%20clean%20centered%20composition&width=600&height=800&seq=movie-wandering-earth-3&orientation=portrait',
    isHot: true,
    isNew: true,
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
  },
  {
    id: 'movie-2',
    title: '哪吒之魔童闹海',
    titleEn: 'Nezha: The Devil Child Havoc in the Sea',
    year: 2025,
    rating: 8.9,
    genre: '动画',
    region: '中国大陆',
    duration: '132分钟',
    quality: '蓝光1080P',
    description: '天劫之后，哪吒、敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。但是在重塑肉身的过程中却遇到重重困难，哪吒、敖丙的命运将走向何方？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20mythological%20hero%20poster%2C%20fierce%20young%20warrior%20with%20flaming%20spear%2C%20traditional%20Chinese%20art%20style%20with%20dynamic%20fire%20effects%2C%20vibrant%20red%20and%20gold%20tones%2C%20epic%20cinematic%20lighting&width=600&height=800&seq=movie-nezha-2&orientation=portrait',
    isHot: true,
    isNew: false,
    cast: ['吕艳婷', '瀚墨', '陈浩', '绿绮'],
  },
  {
    id: 'movie-3',
    title: '封神第二部',
    titleEn: 'Creation of the Gods 2',
    year: 2025,
    rating: 8.2,
    genre: '动作',
    region: '中国大陆',
    duration: '145分钟',
    quality: '蓝光1080P',
    description: '殷寿残暴无道，各方势力暗流涌动。姬发在殷商王都卧薪尝胆，寻找时机推翻暴政。姜子牙携封神榜下山，一场改变天下格局的大战即将展开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20war%20film%20poster%2C%20warriors%20in%20traditional%20armor%20with%20epic%20battle%20scene%2C%20dramatic%20stormy%20sky%2C%20golden%20and%20crimson%20tones%2C%20cinematic%20blockbuster%20style&width=600&height=800&seq=movie-fengshen-2&orientation=portrait',
    isHot: true,
    isNew: false,
    cast: ['费翔', '黄渤', '于适', '李雪健', '夏雨'],
  },
  {
    id: 'movie-4',
    title: '满江红',
    titleEn: 'Full River Red',
    year: 2024,
    rating: 8.0,
    genre: '剧情',
    region: '中国大陆',
    duration: '159分钟',
    quality: '蓝光1080P',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。金国使者死在宰相驻地，所携密信不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大的阴谋之中。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20film%20poster%2C%20ancient%20Chinese%20courtyard%20at%20night%2C%20mysterious%20atmosphere%2C%20deep%20red%20lanterns%2C%20suspenseful%20cinematic%20lighting%2C%20Song%20dynasty%20aesthetic&width=600&height=800&seq=movie-manjianghong&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
  },
  {
    id: 'movie-5',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    year: 2024,
    rating: 7.9,
    genre: '剧情',
    region: '中国大陆',
    duration: '136分钟',
    quality: '蓝光1080P',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20film%20poster%2C%20urban%20danger%20mood%2C%20neon%20lit%20atmosphere%2C%20intense%20facial%20expressions%2C%20gritty%20realistic%20style%2C%20deep%20shadows%20and%20contrast&width=600&height=800&seq=movie-guzhuyizhi&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
  },
  {
    id: 'movie-6',
    title: '飞驰人生2',
    titleEn: 'Pegasus 2',
    year: 2024,
    rating: 7.8,
    genre: '喜剧',
    region: '中国大陆',
    duration: '128分钟',
    quality: '蓝光1080P',
    description: '曾经叱咤风云的拉力赛车手张驰，沦为落魄驾校教练。机缘巧合下，他得到了重返车坛的机会，决定再战巴音布鲁克拉力赛。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Racing%20comedy%20film%20poster%2C%20rally%20car%20on%20desert%20track%2C%20dust%20and%20speed%2C%20warm%20sunset%20tones%2C%20inspirational%20sports%20movie%20vibe%2C%20dynamic%20action%20composition&width=600&height=800&seq=movie-feichirensheng2&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
  },
  {
    id: 'movie-7',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    year: 2024,
    rating: 7.6,
    genre: '剧情',
    region: '中国大陆',
    duration: '129分钟',
    quality: '蓝光1080P',
    description: '乐莹是一个善良的人，却一直过着与世无争的生活。在经历了一系列挫折后，她决定通过拳击这项运动来改变自己，找到属于自己的人生方向。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Inspirational%20drama%20film%20poster%2C%20female%20boxer%20in%20training%2C%20determined%20expression%2C%20gym%20atmosphere%2C%20warm%20motivational%20lighting%2C%20empowering%20cinematic%20style&width=600&height=800&seq=movie-relaguntang&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
  },
  {
    id: 'movie-8',
    title: '第二十条',
    titleEn: 'Article 20',
    year: 2024,
    rating: 8.1,
    genre: '剧情',
    region: '中国大陆',
    duration: '141分钟',
    quality: '蓝光1080P',
    description: '人到中年的检察官韩明卷入了一桩分歧巨大的案件。面对情与法的拷问，他不得不在事业和家庭之间做出艰难抉择，坚守法治信仰。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Legal%20drama%20film%20poster%2C%20courtroom%20scene%2C%20serious%20judge%20and%20lawyers%2C%20warm%20dramatic%20lighting%2C%20dignified%20atmosphere%2C%20Chinese%20legal%20system%20aesthetic&width=600&height=800&seq=movie-diershitiao&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['雷佳音', '马丽', '赵丽颖', '高叶', '刘耀文'],
  },
];

export const hotTVShows: TVShow[] = [
  {
    id: 'tv-1',
    title: '庆余年第二季',
    titleEn: 'Joy of Life Season 2',
    year: 2024,
    rating: 8.7,
    genre: '剧情',
    region: '中国大陆',
    episodes: 36,
    quality: '蓝光1080P',
    description: '范闲在经历了生死考验后，继续在庆国这个复杂的权力场中周旋。面对各方势力的博弈，他凭借智慧和胆识一步步揭开隐藏在背后的巨大阴谋。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20poster%2C%20elegant%20scholar%20in%20traditional%20robe%2C%20ancient%20Chinese%20palace%20background%2C%20dramatic%20cinematic%20lighting%2C%20golden%20and%20dark%20tones&width=600&height=800&seq=tv-qingyunian2&orientation=portrait',
    isHot: true,
    isNew: true,
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
  },
  {
    id: 'tv-2',
    title: '狂飙',
    titleEn: 'The Knockout',
    year: 2023,
    rating: 9.1,
    genre: '剧情',
    region: '中国大陆',
    episodes: 39,
    quality: '蓝光1080P',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开长达二十年的生死较量。通过群像叙事，展现扫黑行动中的黑白较量与复杂人性。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20poster%2C%20police%20officer%20versus%20gangster%2C%20dark%20urban%20streets%2C%20intense%20standoff%2C%20gritty%20realism%2C%20neon%20and%20shadow%20contrast&width=600&height=800&seq=tv-kuangbiao&orientation=portrait',
    isHot: true,
    isNew: false,
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
  },
  {
    id: 'tv-3',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    year: 2024,
    rating: 8.9,
    genre: '剧情',
    region: '中国大陆',
    episodes: 30,
    quality: '蓝光1080P',
    description: '上世纪九十年代初，煌煌大时代，人人争上游。阿宝由平凡青年变为商界后起之秀，在沪上弄潮儿女中留下一段传奇。有过金碧辉煌，有过细水长流，男男女女，涨涨跌跌，道尽一个时代的情义与至真。',
    imageUrl: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20TV%20poster%2C%20elegant%20man%20and%20woman%20in%20vintage%20fashion%2C%20neon%20Shanghai%20night%20scene%2C%20nostalgic%20golden%20tones%2C%20Wong%20Kar-wai%20cinematic%20aesthetic&width=600&height=800&seq=tv-fanhua&orientation=portrait',
    isHot: true,
    isNew: false,
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
  },
  {
    id: 'tv-4',
    title: '三体',
    titleEn: 'Three-Body',
    year: 2023,
    rating: 8.5,
    genre: '科幻',
    region: '中国大陆',
    episodes: 30,
    quality: '蓝光1080P',
    description: '宇宙文明之间的博弈，人类面对外星文明"三体人"入侵的危机。纳米科学家汪淼与警察史强共同揭开三体世界的秘密，一场跨越时空的文明对决拉开序幕。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20thriller%20TV%20poster%2C%20mysterious%20cosmic%20phenomenon%2C%20scientists%20facing%20unknown%2C%20deep%20space%20and%20stars%2C%20cold%20blue%20and%20dark%20tones%2C%20philosophical%20science%20fiction%20aesthetic&width=600&height=800&seq=tv-santi&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
  },
  {
    id: 'tv-5',
    title: '长相思',
    titleEn: 'Lost You Forever',
    year: 2023,
    rating: 8.0,
    genre: '爱情',
    region: '中国大陆',
    episodes: 39,
    quality: '蓝光1080P',
    description: '上古时期，人、神、妖混居。流落大荒的皓翎王姬小夭历经百年颠沛之苦，在清水镇以玟小六的身份悬壶济世。与表哥玱玹、涂山璟、相柳等人相遇，上演了一场关于爱情与守护的故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20poster%2C%20beautiful%20woman%20in%20ancient%20flowing%20robes%2C%20ethereal%20mythological%20landscape%2C%20soft%20dreamy%20lighting%2C%20romantic%20wuxia%20aesthetic&width=600&height=800&seq=tv-zhangxiangsi&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['杨紫', '张晚意', '邓为', '檀健次', '代露娃'],
  },
  {
    id: 'tv-6',
    title: '莲花楼',
    titleEn: 'Mysterious Lotus Casebook',
    year: 2023,
    rating: 8.4,
    genre: '动作',
    region: '中国大陆',
    episodes: 40,
    quality: '蓝光1080P',
    description: '闻名武林的四顾门门主李相夷在一次大战后身受重伤，从此退隐江湖成为淡泊名利的"假神医"李莲花。在遇到新交方多病与旧敌笛飞声后，三人携手屡破江湖奇案。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20TV%20poster%2C%20wandering%20swordsman%20in%20traditional%20robes%2C%20ancient%20Chinese%20landscape%2C%20misty%20mountains%2C%20elegant%20wuxia%20cinematic%20style&width=600&height=800&seq=tv-lianhualou&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['成毅', '曾舜晞', '肖顺尧', '陈都灵', '王鹤润'],
  },
  {
    id: 'tv-7',
    title: '漫长的季节',
    titleEn: 'The Long Season',
    year: 2023,
    rating: 9.4,
    genre: '剧情',
    region: '中国大陆',
    episodes: 12,
    quality: '蓝光1080P',
    description: '小城桦林，出租车司机王响因一桩套牌案重新卷入二十年前的一桩悬案。过去与现在交织，几个人物的命运紧紧联系在一起，揭开了那个漫长秋天里被掩埋的真相。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Northeast%20China%20small%20town%20drama%20TV%20poster%2C%20middle-aged%20taxi%20driver%2C%20autumn%20atmosphere%2C%20nostalgic%20melancholic%20mood%2C%20warm%20golden%20light%2C%20art%20house%20film%20aesthetic&width=600&height=800&seq=tv-manchangdejijie&orientation=portrait',
    isHot: false,
    isNew: false,
    cast: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
  },
  {
    id: 'tv-8',
    title: '唐朝诡事录之西行',
    titleEn: 'Strange Tales of Tang Dynasty',
    year: 2024,
    rating: 8.3,
    genre: '动作',
    region: '中国大陆',
    episodes: 36,
    quality: '蓝光1080P',
    description: '大唐盛世之下，奇案频发。苏无名与卢凌风一路西行，卷入一桩桩诡异的案件中。在探索真相的过程中，他们发现每起案件背后都隐藏着不为人知的秘密。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20mystery%20thriller%20TV%20poster%2C%20ancient%20Chinese%20detectives%2C%20mysterious%20silk%20road%20setting%2C%20dramatic%20lighting%2C%20oriental%20Gothic%20atmosphere%2C%20suspenseful%20cinematic%20style&width=600&height=800&seq=tv-tangchaogui&orientation=portrait',
    isHot: true,
    isNew: true,
    cast: ['杨旭文', '杨志刚', '郜思雯', '孙雪宁', '陈创'],
  },
];